module.exports = __webpack_public_path__ + "img/3.91d81a0c.jpg";